var $ = jQuery.noConflict();
var xMousePos = 0;
var yMousePos = 0;
var masonryProjects;
var masonryArticles;
var isotopeProjects;
let projectSiteMasonries;

// breakpoints
var bpXs = 350,
    bpSm = 400,
    bpMd = 768,
    bpLg = 992,
    bpXl = 1200,
    bpXxl = 1500;


// SEARCH

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}


jQuery(document).ready(function () {

  const lazyLoadInstance = new LazyLoad({
    thresholds: "200% 0px"
  });

  // isotope
  if (document.querySelector('.isotope-project_grid')) {

    isotopeProjects = new Isotope('.isotope-project_gridff .grid', {
      itemSelector: '.grid-item',
      layoutMode: 'masonry',
      masonry: {
        columnWidth: '.grid-item',
      },
      hiddenStyle: {
        transform: 'scale(.9) translateY(15px)',
        opacity: 0
      },
      visibleStyle: {
        transform: 'scale(1) translateY(0)',
        opacity: 1
      }
    });

    // Search
    const projectSearch = document.getElementById('projectSearch');
    const gridItems = document.querySelectorAll('.grid-item.visible');
    projectSearch.addEventListener('keyup', () => {
      searchProject(projectSearch.value);
    });
    //isotopeProjects.hideItemElements(gridItems);

    const searchProject = debounce(() => {
      searchString = document.getElementById('projectSearch').value.toLowerCase().replace(' ','-');
      if (searchString.length > 3) {
        gridItems.forEach((item) => { item.classList.remove('visible'); });
        searchResult = document.querySelectorAll('.grid-item[data-title*="' + searchString + '"]');
        if (searchResult) {
          searchResult.forEach((result) => { result.classList.add('visible'); });
          isotopeProjects.arrange();
        }
      } else if (searchString.length === 0) {
        gridItems.forEach((item) => { item.classList.add('visible'); });
        isotopeProjects.arrange({ filter: '*' });
      }
    }, 300);


    // Filter
    const filters = document.querySelectorAll('.projectFilter');
    filters.forEach((filter) => {
      filter.addEventListener('change', () => {
          document.querySelectorAll('.grid-item').forEach((item) => {
            item.classList.add('visible');
          });
          document.querySelectorAll('.grid-item').forEach((item) => {
            filters.forEach((filter) => {
              if(filter.value=="all") {
                return
              }
              if(!item.classList.contains(filter.value)) {
                item.classList.remove('visible');
              }
            });
          });
      });
    });
  }

  var fancyboxGallery = jQuery('[data-fancybox="gallery"]').fancybox({
    arrows: false,
    infobar: false,
    smallBtn: false,
    toolbar: false,
    animationEffect: "zoom",
    transitionEffect: "slide",
    transitionDuration: 750,
    type: "image",
    buttons: [],
    image: {
      preload: false
    },
    spinnerTpl: '<div id="loaderContainer" class="loader-container"><div class="loader"><div class="loader-stripe"></div></div></div>',
    clickContent: function(current, event) {
      return current.type === "image" ? false : false;
    },
    video: {
      tpl:
        '<video class="fancybox-video" loop muted controlsList="nodownload" poster="{{poster}}">' +
        '<source src="{{src}}" type="{{format}}" />' +
        'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
        "</video>",
      format: "", // custom video format
      autoStart: true
    },
  });

  // swiper js project page
  var swiperProjectPage = new Swiper('.static-swiper-container', {
    speed: 1500,
    loop: true,
    slideNextClass: 'right',
    slideNextClass: 'left',
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', },
    grabCursor: true,
    centeredSlides: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
  });

  // swiper js front page
  if(document.querySelectorAll('.block-intro_swiper_gallery .swiper-slide').length > 1) {
    var swiperFeaturedProjects = new Swiper('.block-intro_swiper_gallery.swiper-container', {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      simulateTouch: false,
      draggable: false,
      speed: 1500,
      loop: true,
      slideNextClass: 'right',
      slideNextClass: 'left',
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', },
      grabCursor: true,
      centeredSlides: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    });
  }

  // swiper js front page
  var swiperArticles = new Swiper('.article-grid .grid-container', {
    slidesPerView: 1,
    wrapperClass: 'swiper-wrapper',
    scrollbar: {
      el: '.scrollbar',
      draggable: true,
      hide: false,
    },
    navigation: { nextEl: '.button.right', prevEl: '.button.left', },
    speed: 1500,
    grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
    },
  });

  // swiper js horizontal scroll
  var swiperArticles = new Swiper('.swiper-horizontal_scroll .grid-container', {
    slidesPerView: 1,
    wrapperClass: 'swiper-wrapper',
    scrollbar: {
      el: '.scrollbar',
      draggable: true,
      hide: false,
    },
    navigation: { nextEl: '.button.right', prevEl: '.button.left', },
    speed: 1500,
    grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
    },
  });

  // swiper js logo grid
  var swiperLogoGrid = new Swiper('.logo-swiper-container', {
    slidesPerView: 3,
    freeMode: true,
    loop: true,
    speed: 10000,
    simulateTouch: false,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      768: {
        slidesPerView: 6,
      },
      1200: {
        slidesPerView: 8
      }
    },
  });


  if(swiperFeaturedProjects[0]) {
    swiperFeaturedProjects[0].autoplay.stop();
    swiperFeaturedProjects[1].autoplay.stop();

    jQuery(window).on('load', function () {
      jQuery('.progress').addClass('start');
      setTimeout(function () {
        swiperFeaturedProjects[0].autoplay.start();
        swiperFeaturedProjects[1].autoplay.start();
      }, 1000);
    });

    swiperFeaturedProjects[0].on('autoplayStart', function () {
      jQuery('.progress').addClass('start');
    });

    swiperFeaturedProjects[0].on('slideChange', function () {
      jQuery('.progress').removeClass('start');
      setTimeout(function () {
        jQuery('.progress').addClass('start');
      }, 600);
    });

    swiperFeaturedProjects[0].on('beforeDestroy', function () {
    });

    swiperFeaturedProjects[0].on('touchMove', function () {
      swiperFeaturedProjects[0].autoplay.stop();
      swiperFeaturedProjects[1].autoplay.stop();
      jQuery('.progress').removeClass('start');
    });

    swiperFeaturedProjects[0].on('slidePrevTransitionStart', function() {
      swiperFeaturedProjects[0].autoplay.stop();
      swiperFeaturedProjects[1].autoplay.stop();
      swiperFeaturedProjects[1].slidePrev(900);
      jQuery('.progress').removeClass('start');
    });

    swiperFeaturedProjects[0].on('slideNextTransitionStart', function() {
      swiperFeaturedProjects[0].autoplay.stop();
      swiperFeaturedProjects[1].autoplay.stop();
      swiperFeaturedProjects[1].slideNext(900);
      jQuery('.progress').removeClass('start');
    });

    swiperFeaturedProjects[0].on('slideNextTransitionEnd', function () {
      swiperFeaturedProjects[0].autoplay.start();
      swiperFeaturedProjects[1].autoplay.start();
    });

    swiperFeaturedProjects[0].on('slidePrevTransitionEnd', function () {
      swiperFeaturedProjects[0].autoplay.start();
      swiperFeaturedProjects[1].autoplay.start();
    });

  }

});

jQuery(window).on('load', function () {

  masonryProjects = jQuery('.block-project_grid_off .grid').masonry({
    // options
    itemSelector: '.grid-item',
  });

  masonryArticles = jQuery('.blog .section-articles_grid .grid').masonry({
    itemSelector: '.grid-item',
  });

  projectSiteMasonries = jQuery('.image-block.config-3 .gallery, .image-block.config-5 .gallery').masonry({
    itemSelector: '.image-wrapper',
  });

  jQuery('.fixed-navigation-button, .fixed-navigation-overlay').on('click', function () {
    jQuery('body').toggleClass('fixed-navigation-open');
  });


  // cursor
  jQuery(document).mousemove( function (e) {
    captureMousePosition(e);
    jQuery("#cursor").css({left:e.pageX, top:e.pageY});
  });

  jQuery(window).on('scroll', function (e) {
    yPos = yMousePos + jQuery(window).scrollTop()
    jQuery("#cursor").css({left:e.pageX, top:yPos});
  });

  jQuery(document).on('dragover', function (e) {
    xPos = e.pageX;
    yPos = e.pageY;
    jQuery('#cursor').css({left:xPos, top:yPos});
  })
 

  jQuery('.article-grid a.grid-item, .block-project_grid a.grid-item, .isotope-project_grid a.grid-item').on('mouseover', function () {
    jQuery('#cursor').addClass('visible');
  }).on('mouseleave', function () {
    jQuery('#cursor').removeClass('visible');
  });

  jQuery('.projects .control.right').on('mouseover', function () {
    jQuery('#cursor').addClass('visible right');
  }).on('mouseleave', function () {
    jQuery('#cursor').removeClass('visible right');
  });

  jQuery('.projects .control.left').on('mouseover', function () {
    jQuery('#cursor').addClass('visible left');
  }).on('mouseleave', function () {
    jQuery('#cursor').removeClass('visible left');
  });

  jQuery('.projects .gallery-item').on('mouseover', function () {
    jQuery('#cursor').addClass('visible zoom');
  }).on('mouseleave', function () {
    jQuery('#cursor').removeClass('visible zoom');
  });

  jQuery('.projects .fancybox-slide--current').on('mouseover', function () {
    jQuery('#cursor').addClass('visible close');
  }).on('mouseleave', function () {
    jQuery('#cursor').removeClass('visible close');
  });

  document.querySelectorAll('.accordion h2').forEach(function(el) {
    el.addEventListener('click', function() {
        var id = el.parentElement.parentElement.parentElement.id;
        var accordion = document.getElementById(id);
        if(!accordion.classList.contains('active')) {
          accordion.classList.add('active');
          var content = jQuery("#"+id+" .inner>div").innerHeight();
          accordion.querySelector('.inner').style.height = content + 'px'; 
        } else {
          accordion.classList.remove('active');
          accordion.querySelector('.inner').style.height = 0; 
        }
        document.querySelectorAll('.accordion:not(#'+id+')').forEach(function(el) {
            el.querySelector('.inner').style.height = 0; 
            el.classList.remove('active');
        });
    });
  })

});

function captureMousePosition(e) {
  xMousePos = e.pageX;
  yMousePos = e.pageY - jQuery(window).scrollTop();
}
